<template>
    <div class="signup-footer">
	<div class="container">
		<h3>Start sending now with our competitive rates!</h3>


		<router-link :to="'/account/registration/initial'" class="theme-btn">Sign Up Now</router-link>
		
		<!-- <div class="show-promotion">
		
			<router-link :to="'/promotion'" class="theme-btn promotion-btn"><i class="material-icons">add</i> Show Promotions</router-link>
		</div> -->
	</div>
	<!-- <promotion /> -->
	<div class="divider"></div>
</div>
</template>
<script>
import Promotion from '../../components/promotion'

export default {
	components: { Promotion },
}
</script>
